

import FmdGoodIcon from '@mui/icons-material/FmdGood';
import S from './SingleDam.module.css'
import E from './ListDam.module.css'
import W from './ListDam.module.css'

import {  Edit, Key, Sensors, Settings } from '@mui/icons-material'
import ReportIcon from '@mui/icons-material/Report';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useEffect, useState } from 'react'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { useGlobalContext } from '../Components/Context'
import G from '../images/term.svg'

import AddTerminal from '../Components/AddTerminalModal';

import TerminalsComp from '../Components/DeviceList/TerminalList';

const Terminals=()=>{

    const {isOpenModal,closeModalls,openModalls}=useGlobalContext();

 
    return <>
    <div className={S.SingleDamCon}>
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
    <div className={S.SingleDamTitleCon}>
    <img style={{width:'72px',height:'72px'}} className={S.SingleDamimgTit} src={G}/>
        <h2> ترمینال ها</h2>
        </div>
        <div onClick={()=>{openModalls()}} data-title='افزودن  جدید' className={`${E.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
        </div>
    </div>

        <hr/>
        <TerminalsComp/>
        
        
            


    </div>
    {isOpenModal&&<AddTerminal/>}
    </>
}

export default Terminals